import { useTranslation } from "react-i18next";

const paymentGatewayOptionsOperationOffline = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "alipay",
      title: t("options.gatewayOperation.offline.alipay"),
      value: "ALIPAY",
    },
    {
      key: "allinpay",
      title: t("options.gatewayOperation.offline.allinpay"),
      value: "ALLINPAY",
    },
    {
      key: "amex",
      title: t("options.gatewayOperation.offline.amex"),
      value: "AMEX",
    },
    {
      key: "amex_bbmsl",
      title: t("options.gatewayOperation.offline.amex_bbmsl"),
      value: "AMEX_BBMSL",
    },
    {
      key: "dbs",
      title: t("options.gatewayOperation.offline.dbs"),
      value: "DBS",
    },
    {
      key: "dsb",
      title: t("options.gatewayOperation.offline.dsb"),
      value: "DSB",
    },
    {
      key: "fubon",
      title: t("options.gatewayOperation.offline.fubon"),
      value: "FUBON",
    },
    {
      key: "globalpayments",
      title: t("options.gatewayOperation.offline.globalpayments"),
      value: "GLOBALPAYMENTS",
    },
    {
      key: "hsbc",
      title: t("options.gatewayOperation.offline.hsbc"),
      value: "HSBC",
    },
    {
      key: "octopus",
      title: t("options.gatewayOperation.offline.octopus"),
      value: "OCTOPUS",
    },
    {
      key: "octopus_bbmsl",
      title: t("options.gatewayOperation.offline.octopus_bbmsl"),
      value: "OCTOPUS_BBMSL",
    },
    {
      key: "octopus_hkbn",
      title: t("options.gatewayOperation.offline.octopus_hkbn"),
      value: "OCTOPUS_HKBN",
    },
    {
      key: "wechat_pay",
      title: t("options.gatewayOperation.offline.wechat_pay"),
      value: "WECHAT_PAY",
    },
    {
      key: "yedpay",
      title: t("options.gatewayOperation.offline.yedpay"),
      value: "YEDPAY",
    },
    {
      key: "mock",
      title: t("options.gatewayOperation.offline.mock"),
      value: "MOCK",
    }
  ].filter(
    (option) =>
      !(process.env.REACT_APP_ENV === "prod" && option.key === "mock"),
  );

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default paymentGatewayOptionsOperationOffline;
